/**
 * @desc 根据code获取商户基本信息接口
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** paymentCode */
  paymentCode: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/merchant/info',
    params,
    method: 'get',
  })
}
